/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { Namespace } from './Namespace.js'

export const Environment = z.object({
  addons: z.array(z.string()),
  awsAccountID: z.string(),
  id: z.string(),
  name: z.string(),
  namespaces: z.array(Namespace)
})

export interface Environment extends z.TypeOf<typeof Environment> {}
